import { useAuth0 } from '@auth0/auth0-react';
import { ComponentType, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import {
  setAccessTokenGetter,
  setAuth0Logout,
} from '../../utils/apiService/apiService';

interface PrivateRouteProps {
  requireNotification?: boolean;
  isNotified: boolean;
  Component: ComponentType<any>;
}

const PrivateRoute = (props: PrivateRouteProps) => {
  const { requireNotification, isNotified, Component } = props;

  const { isAuthenticated, isLoading, getAccessTokenSilently, logout } =
    useAuth0();

  useEffect(() => {
    setAccessTokenGetter(getAccessTokenSilently);
  }, [getAccessTokenSilently]);

  useEffect(() => {
    setAuth0Logout(logout);
  }, [logout]);

  if (isLoading) {
    return <div></div>;
  }
  if (!isAuthenticated) {
    return <Navigate to="/login" />;
  }
  if (requireNotification && !isNotified) {
    return <Navigate to="/" />;
  }
  return <Component />;
};

export default PrivateRoute;
